const CORRELATION_TTL_MS = 5 * 60 * 1_000;
const MAX_CORRELATIONS = 100;

interface LocalConversationFrameCorrelation {
  frameId: string;
  spaceId: string;
  createdAt: number;
}

const correlations = new Map<string, LocalConversationFrameCorrelation>();

function pruneExpiredCorrelations(now = Date.now()): void {
  for (const [requestId, correlation] of correlations) {
    if (now - correlation.createdAt > CORRELATION_TTL_MS) {
      correlations.delete(requestId);
    }
  }
}

export function registerLocalConversationFrameCorrelation({
  frameId,
  spaceId,
  requestId = crypto.randomUUID(),
}: {
  frameId: string;
  spaceId: string;
  requestId?: string;
}): string {
  pruneExpiredCorrelations();
  if (correlations.size >= MAX_CORRELATIONS) {
    const oldestRequestId = correlations.keys().next().value;
    if (oldestRequestId) correlations.delete(oldestRequestId);
  }
  correlations.set(requestId, { frameId, spaceId, createdAt: Date.now() });
  return requestId;
}

export function localConversationFrameForRequest(
  requestId: string | undefined,
  spaceId: string | undefined,
): string | undefined {
  if (!requestId || !spaceId) return undefined;
  pruneExpiredCorrelations();
  const correlation = correlations.get(requestId);
  return correlation?.spaceId === spaceId ? correlation.frameId : undefined;
}

export function releaseLocalConversationFrameCorrelation(
  requestId: string | undefined,
): void {
  if (requestId) correlations.delete(requestId);
}

export function resetLocalConversationFrameCorrelations(): void {
  correlations.clear();
}
